import { Banner, Box2 } from '@zoomit/icons';

import type { SearchInstanceResult } from '../types/search';

export const hotContents = [
  { title: 'قیمت امروز گوشی', slug: '/list/mobile' },
  { title: 'قیمت آیفون', slug: '/list/mobile/apple' },
  { title: 'قیمت لپ‌تاپ', slug: '/list/laptop' },
  { title: 'قیمت گوشی سامسونگ', slug: '/list/mobile/samsung' },
  { title: 'قیمت تلویزیون', slug: '/list/tv' },
];

export const resultContents: SearchInstanceResult[] = [
  {
    title: 'محصولات',
    icon: (color: string) => <Box2 fill={color} />,
    maxCount: 6,
    value: 'products',
  },
  {
    title: 'مطالب',
    icon: (color: string) => <Banner fill={color} />,
    maxCount: 5,
    value: 'articles',
  },
];
